import mongoose from 'mongoose';

export enum EDealStatus {
  inactive,
  active
}

export interface IDealOfTheDay {
  dealName: string;
  bannerImage: mongoose.Types.ObjectId;
  products: {
    productId: mongoose.Types.ObjectId;
    discountPercentage: number;
    expiredDate: string;
    status: EDealStatus;
  }[];
}
